import RootReducer from "./reducer/rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";

const Store = configureStore({
    reducer: RootReducer,
    composeWithDevTools
})

export default Store